import { DefaultState } from '@src/redux/types'

import { MOBILE_SETTINGS, MOBILE_SETTINGS_VERSIONS } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [MOBILE_SETTINGS]: DefaultState<`${typeof API.MOBILE_SETTINGS}`, 'post'>
  [MOBILE_SETTINGS_VERSIONS]: DefaultState<`${typeof API.MOBILE_SETTINGS_VERSIONS}`, 'get'>
} = () => ({
  [MOBILE_SETTINGS]: defaultState(),
  [MOBILE_SETTINGS_VERSIONS]: defaultState(),
})
